import React from 'react';
import ReactDOM from 'react-dom';
import * as history from 'history';
import { Router, Switch } from 'react-router-dom';
import { IntlProvider } from 'react-intl';

import { appGalleryI18n, LOCALES } from '@marketplace/i18n';

import * as serviceWorker from './app/serviceWorker';
import { ProtectedRoute, EmbedModeWithContext } from './features';
import {
  AppGalleryPage,
  ApplicationPage,
  NotFoundPage,
  EmbedPage,
} from './app/pages';
import { ROUTES } from './app/constants';

import './styles.scss';

const browserHistory = history.createBrowserHistory();

export const app = (
  <IntlProvider locale={LOCALES.ENG} messages={appGalleryI18n[LOCALES.ENG]}>
    <EmbedModeWithContext>
      <Router history={browserHistory}>
        <Switch>
          <ProtectedRoute exact path={ROUTES.EMBED} component={EmbedPage} />
          <ProtectedRoute
            exact
            path={ROUTES.APPLICATION}
            component={ApplicationPage}
          />
          <ProtectedRoute
            exact
            path={ROUTES.MARKETPLACE}
            component={AppGalleryPage}
          />
          <ProtectedRoute path="*" render={NotFoundPage} />
        </Switch>
        <div hidden id="app-gallery-version">
          {process.env.NX_BUILD_NUMBER}
        </div>
      </Router>
    </EmbedModeWithContext>
  </IntlProvider>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
